
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexzptzx5P6j_jGnp9gxTTqeNWlHz97s9DclCA8d14Cq_YMeta } from "/grouper/web-frontend/modules/core/pages/index.vue?macro=true";
import { default as debugS7NkHsFushxD_UxpAN7lK7uK7nRiKeabGEZ_KLtHzuUMeta } from "/grouper/web-frontend/modules/core/pages/debug.vue?macro=true";
import { default as loginIPZBq9RlN2GV_ovVb3Kaog8L2wYKFNr39p1j6k53UGUMeta } from "/grouper/web-frontend/modules/core/pages/login.vue?macro=true";
import { default as signuphDQEcKrRCUICRE_HT2IjfMC0JJlI8JJda1L6IdEr5LsMeta } from "/grouper/web-frontend/modules/core/pages/signup.vue?macro=true";
import { default as forgotPassword_5_XPozcctv_N0ErtwrlIIq6SZ5wrt4qxS8ayQXpZT0Meta } from "/grouper/web-frontend/modules/core/pages/forgotPassword.vue?macro=true";
import { default as resetPasswordoaa7r3GD5XcbIuX590zzg6vOehAGmCSYc1rhhvJXf2UMeta } from "/grouper/web-frontend/modules/core/pages/resetPassword.vue?macro=true";
import { default as changeEmail3bd17MxxGVGng8UuoKQ8_YfaDnUpNiNSos6rOkNtA4kMeta } from "/grouper/web-frontend/modules/core/pages/changeEmail.vue?macro=true";
import { default as verifyEmailAddressSss_EXzz3NnXv5tDgqWGnTD1LOHVe1KpkUI1z9MLREQMeta } from "/grouper/web-frontend/modules/core/pages/verifyEmailAddress.vue?macro=true";
import { default as styleGuidepEvzFYWr5ECy2EZqiph711lX2t52ryfDrpFFXjIC9_4Meta } from "/grouper/web-frontend/modules/core/pages/styleGuide.vue?macro=true";
import { default as loginWithSAMLZbFBHy_EEz7UV5ewXzUN_qp1MFmc1Zt7IbVGN4FO8r8Meta } from "/grouper/enterprise/web-frontend/modules/grouper_enterprise/pages/login/loginWithSAML.vue?macro=true";
import { default as loginErrordvgu0NOdsLZU1SCNkx8vXmKPiMZjltGBNOT2X9q3CEMMeta } from "/grouper/enterprise/web-frontend/modules/grouper_enterprise/pages/login/loginError.vue?macro=true";
import { default as loginPagesNqwDB8FyGJxaR0Reoc0__n0gcMHqZNx73_SeDP7CK_IMeta } from "/grouper/web-frontend/modules/core/pages/loginPages.vue?macro=true";
import { default as dashboardg92YrGxFpr_qgr_hWsVntCx7C2or0xMl8N8rH5wiI3wMeta } from "/grouper/web-frontend/modules/core/pages/dashboard.vue?macro=true";
import { default as workspacexIRXpWBVaUaPbmWEQOaI9r1VBsY7b57syPnImCOiCQcMeta } from "/grouper/web-frontend/modules/core/pages/workspace.vue?macro=true";
import { default as settingsfbq5Xp4opLmKRgKflQOPPe7V7KMKhQGWkzgGWlGan_AMeta } from "/grouper/web-frontend/modules/core/pages/admin/settings.vue?macro=true";
import { default as aiProvidersYdKMletqu6Mc735xEkO2Q6vnRvr0jquapznTka36ry4Meta } from "/grouper/web-frontend/modules/core/pages/admin/aiProviders.vue?macro=true";
import { default as health_W8KZKPbvBpIz9zcvXzBH_7PgvwiRHkvIH02r6F_Os0Meta } from "/grouper/web-frontend/modules/core/pages/admin/health.vue?macro=true";
import { default as dashboardibHy526DBWTMw7LnuhbP_ASHWO7ev_kVZJYNmFzzkiAMeta } from "/grouper/web-frontend/modules/core/pages/admin/dashboard.vue?macro=true";
import { default as users7kG64hMCTB1kpo8F_3iD4s15kDfkd8TkvR68CFQn7qIMeta } from "/grouper/web-frontend/modules/core/pages/admin/users.vue?macro=true";
import { default as workspacesagFEMlXgJzj4TC3ONXqubYqn7zFvywOuy_yjVRm4a7QMeta } from "/grouper/web-frontend/modules/core/pages/admin/workspaces.vue?macro=true";
import { default as members6gtVL8S4YVrdaJWIDafY9xM35h9qzETBLrQreYBsySwMeta } from "/grouper/web-frontend/modules/core/pages/settings/members.vue?macro=true";
import { default as invitesYq4DKiA9_K0igc7OCTcrP_xkdhe4xWq5C2qOJYulZhQMeta } from "/grouper/web-frontend/modules/core/pages/settings/invites.vue?macro=true";
import { default as teamssNzVz2CawkWb08YI6S6EU9lvByYoRn7NGqUoyfPFF_kMeta } from "/grouper/enterprise/web-frontend/modules/grouper_enterprise/pages/settings/teams.vue?macro=true";
import { default as settings1TacgyLZAkGBjKnjJ0FkfQNRCGxhW5_ItW7xS0d8t5YMeta } from "/grouper/web-frontend/modules/core/pages/settings.vue?macro=true";
import { default as viewscNC2nNPoQmxM5VPkYGuShqGkWs3zskcWs6FLuKRjrzoMeta } from "/grouper/web-frontend/modules/database/pages/admin/views.vue?macro=true";
import { default as authProviders2zQuQM5i3_KHznOrfmbdIDVFUb9wY_Y7xrsSEXZ0s_UMeta } from "/grouper/enterprise/web-frontend/modules/grouper_enterprise/pages/admin/authProviders.vue?macro=true";
import { default as auditLogTG8W65YcbUeI3hjsPTBE_QZ57_bthIiF_jLdRWsu0Y4Meta } from "/grouper/enterprise/web-frontend/modules/grouper_enterprise/pages/auditLog.vue?macro=true";
import { default as scansepctSgkcBllS85HzmucWgYIfd7hzptRVYIBfWejMejMMeta } from "/grouper/enterprise/web-frontend/modules/grouper_enterprise/pages/admin/dataScanner/scans.vue?macro=true";
import { default as resultsb6uVdYCAlcIYUTptVNY7z3FgWRO0NKBAv_mPYYSzmcQMeta } from "/grouper/enterprise/web-frontend/modules/grouper_enterprise/pages/admin/dataScanner/results.vue?macro=true";
import { default as dataScannerzn_w6ov_ZNoAniBcQe8z7zW5mU_0hHyrK8SMtQnMwsQMeta } from "/grouper/enterprise/web-frontend/modules/grouper_enterprise/pages/admin/dataScanner.vue?macro=true";
import { default as rootcM0gEAfEOgp_Nt0pMI9M21uSL9JA1UHrM_pHJFZFACcMeta } from "/grouper/web-frontend/modules/core/pages/root.vue?macro=true";
import { default as workspaceInvitationA2gGM9crN51JodifVao1yNmQz2bxtONz8CLJ2vucTLgMeta } from "/grouper/web-frontend/modules/core/pages/workspaceInvitation.vue?macro=true";
import { default as _healthbFpFeJcNwThBzoUHBYKrOxx5AycyHY8_bVzInr9_a5oMeta } from "/grouper/web-frontend/modules/core/pages/_health.vue?macro=true";
import { default as notificationRedirectYdxG3dK5AUTX6m8EfzRZAYJBdnxPEH1ErsvQRr5KWqsMeta } from "/grouper/web-frontend/modules/core/pages/notificationRedirect.vue?macro=true";
import { default as onboardingf4xXMu41Q1D7_0IkWnq8UFOcm4oZOYZXG3X7SzvDWtcMeta } from "/grouper/web-frontend/modules/core/pages/onboarding.vue?macro=true";
import { default as RouterViewPlaceholderWswdgjwGsuzKoAB51y3YMVUsyJx0h2C0xiIkRAF_r8YMeta } from "/grouper/web-frontend/modules/core/components/RouterViewPlaceholder.vue?macro=true";
import { default as webhooksXt2MNevAuUtONQzRIP4Ux6Ml_bQcxWZHXLk87WF8U_kMeta } from "/grouper/web-frontend/modules/database/pages/table/webhooks.vue?macro=true";
import { default as configureDataSyncw_fNc1L4ZsMrEcNf6uR4sZgg0IyBFA5v9To9DlcbsmAMeta } from "/grouper/web-frontend/modules/database/pages/table/configureDataSync.vue?macro=true";
import { default as tableXyFyWTpJnD76w8sU_k6raf1bWMP0nYzwEVHLLrlLAIoMeta } from "/grouper/web-frontend/modules/database/pages/table.vue?macro=true";
import { default as APIDocsL2f4yWNeW2vbYc4UpokxeQa3QQjuGuF73EHTkOk8yP0Meta } from "/grouper/web-frontend/modules/database/pages/APIDocs.vue?macro=true";
import { default as APIDocsDatabaseps8UR5nuX_pSzS983BxKMyZ93a7eHBMlYcljFFyzCOcMeta } from "/grouper/web-frontend/modules/database/pages/APIDocsDatabase.vue?macro=true";
import { default as formuE_gFuC1437lGht4XLwsUxon8gKS46UiLtun7FXGUNsMeta } from "/grouper/web-frontend/modules/database/pages/form.vue?macro=true";
import { default as publicViewdu_KardUei3m9wHURcmIynEG3Z56sE57JnH3i4QXu8oMeta } from "/grouper/web-frontend/modules/database/pages/publicView.vue?macro=true";
import { default as publicViewLoginjhq6miIAhoYj5jxk0lsy5gETn4U_K_94iEMS5CgYvzwMeta } from "/grouper/web-frontend/modules/database/pages/publicViewLogin.vue?macro=true";
import { default as dashboard642NDUzvpj1oMZTbAGWrbfwtIWfQF1jSTxeHO4hdcDsMeta } from "/grouper/web-frontend/modules/dashboard/pages/dashboard.vue?macro=true";
import { default as pageEditorI266LinBIjafvSzOzPbxg2lBdDZVnWuDQHkvsy2z7fgMeta } from "/grouper/web-frontend/modules/builder/pages/pageEditor.vue?macro=true";
import { default as publicPageHyQHi1cSWjQX_4KLKKS87W9jjYfxGWIz7XemltBiLkQMeta } from "/grouper/web-frontend/modules/builder/pages/publicPage.vue?macro=true";
import { default as automationWorkflowISmVSx60pQI5m2_M8JR34WBff1CGxIcq7TtDS2kd00UMeta } from "/grouper/web-frontend/modules/automation/pages/automationWorkflow.vue?macro=true";
import { default as publicViewYosd20xBRtg6zJofICWVhK1HPyG9Mw8Pphb2ZB2Tpr8Meta } from "@grouper/modules/database/pages/publicView.vue?macro=true";
export default [
  {
    name: "index",
    path: "",
    component: () => import("/grouper/web-frontend/modules/core/pages/index.vue")
  },
  {
    name: "debug",
    path: "/debug",
    component: () => import("/grouper/web-frontend/modules/core/pages/debug.vue")
  },
  {
    name: "login-pages",
    path: "",
    meta: { ...(loginPagesNqwDB8FyGJxaR0Reoc0__n0gcMHqZNx73_SeDP7CK_IMeta || {}), ...{"middleware":["settings","urlCheck","settings","urlCheck"]} },
    component: () => import("/grouper/web-frontend/modules/core/pages/loginPages.vue"),
    children: [
  {
    name: "login",
    path: "/login",
    meta: { ...(loginIPZBq9RlN2GV_ovVb3Kaog8L2wYKFNr39p1j6k53UGUMeta || {}), ...{"middleware":["settings","settings"]} },
    component: () => import("/grouper/web-frontend/modules/core/pages/login.vue")
  },
  {
    name: "signup",
    path: "/signup",
    meta: { ...(signuphDQEcKrRCUICRE_HT2IjfMC0JJlI8JJda1L6IdEr5LsMeta || {}), ...{"middleware":["settings","settings"]} },
    component: () => import("/grouper/web-frontend/modules/core/pages/signup.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: forgotPassword_5_XPozcctv_N0ErtwrlIIq6SZ5wrt4qxS8ayQXpZT0Meta || {},
    component: () => import("/grouper/web-frontend/modules/core/pages/forgotPassword.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password/:token",
    meta: {"preventPageViewTracking":true},
    component: () => import("/grouper/web-frontend/modules/core/pages/resetPassword.vue")
  },
  {
    name: "change-email",
    path: "/change-email/:token",
    meta: {"preventPageViewTracking":true},
    component: () => import("/grouper/web-frontend/modules/core/pages/changeEmail.vue")
  },
  {
    name: "verify-email-address",
    path: "/verify-email-address/:token",
    meta: verifyEmailAddressSss_EXzz3NnXv5tDgqWGnTD1LOHVe1KpkUI1z9MLREQMeta || {},
    component: () => import("/grouper/web-frontend/modules/core/pages/verifyEmailAddress.vue")
  },
  {
    name: "style-guide",
    path: "/style-guide",
    component: () => import("/grouper/web-frontend/modules/core/pages/styleGuide.vue")
  },
  {
    name: "login-saml",
    path: "/login/saml",
    meta: loginWithSAMLZbFBHy_EEz7UV5ewXzUN_qp1MFmc1Zt7IbVGN4FO8r8Meta || {},
    component: () => import("/grouper/enterprise/web-frontend/modules/grouper_enterprise/pages/login/loginWithSAML.vue")
  },
  {
    name: "login-error",
    path: "/login/error",
    meta: loginErrordvgu0NOdsLZU1SCNkx8vXmKPiMZjltGBNOT2X9q3CEMMeta || {},
    component: () => import("/grouper/enterprise/web-frontend/modules/grouper_enterprise/pages/login/loginError.vue")
  }
]
  },
  {
    name: "root",
    path: "",
    meta: { ...(rootcM0gEAfEOgp_Nt0pMI9M21uSL9JA1UHrM_pHJFZFACcMeta || {}), ...{"middleware":["settings","authenticated","impersonate","workspacesAndApplications","pendingJobs","settings","authenticated","impersonate","workspacesAndApplications","pendingJobs"]} },
    component: () => import("/grouper/web-frontend/modules/core/pages/root.vue"),
    children: [
  {
    name: "dashboard",
    path: "/dashboard",
    meta: { ...(dashboardg92YrGxFpr_qgr_hWsVntCx7C2or0xMl8N8rH5wiI3wMeta || {}), ...{"middleware":["settings","authenticated","impersonate","workspacesAndApplications","pendingJobs","dashboardRedirect","settings","authenticated","impersonate","workspacesAndApplications","pendingJobs","dashboardRedirect"]} },
    component: () => import("/grouper/web-frontend/modules/core/pages/dashboard.vue")
  },
  {
    name: "workspace",
    path: "/workspace/:workspaceId",
    meta: { ...(workspacexIRXpWBVaUaPbmWEQOaI9r1VBsY7b57syPnImCOiCQcMeta || {}), ...{"middleware":["settings","authenticated","impersonate","workspacesAndApplications","settings","authenticated","impersonate","workspacesAndApplications"]} },
    component: () => import("/grouper/web-frontend/modules/core/pages/workspace.vue")
  },
  {
    name: "admin-settings",
    path: "/admin/settings",
    component: () => import("/grouper/web-frontend/modules/core/pages/admin/settings.vue")
  },
  {
    name: "admin-ai-providers",
    path: "/admin/ai-providers",
    component: () => import("/grouper/web-frontend/modules/core/pages/admin/aiProviders.vue")
  },
  {
    name: "admin-health",
    path: "/admin/health",
    meta: { ...(health_W8KZKPbvBpIz9zcvXzBH_7PgvwiRHkvIH02r6F_Os0Meta || {}), ...{"middleware":"staff"} },
    component: () => import("/grouper/web-frontend/modules/core/pages/admin/health.vue")
  },
  {
    name: "admin-dashboard",
    path: "/admin/dashboard",
    component: () => import("/grouper/web-frontend/modules/core/pages/admin/dashboard.vue")
  },
  {
    name: "admin-users",
    path: "/admin/users",
    component: () => import("/grouper/web-frontend/modules/core/pages/admin/users.vue")
  },
  {
    name: "admin-workspaces",
    path: "/admin/workspaces",
    component: () => import("/grouper/web-frontend/modules/core/pages/admin/workspaces.vue")
  },
  {
    name: "settings",
    path: "/workspace/:workspaceId/settings",
    component: () => import("/grouper/web-frontend/modules/core/pages/settings.vue"),
    children: [
  {
    name: "settings-members",
    path: "members",
    component: () => import("/grouper/web-frontend/modules/core/pages/settings/members.vue")
  },
  {
    name: "settings-invites",
    path: "invites",
    component: () => import("/grouper/web-frontend/modules/core/pages/settings/invites.vue")
  },
  {
    name: "settings-teams",
    path: "teams",
    component: () => import("/grouper/enterprise/web-frontend/modules/grouper_enterprise/pages/settings/teams.vue")
  },
  {
    name: "settings-teams",
    path: "teams",
    component: () => import("/grouper/enterprise/web-frontend/modules/grouper_enterprise/pages/settings/teams.vue")
  }
]
  },
  {
    name: "admin-database-views",
    path: "/admin/database-views",
    component: () => import("/grouper/web-frontend/modules/database/pages/admin/views.vue")
  },
  {
    name: "admin-auth-providers",
    path: "/admin/auth-providers",
    meta: { ...(authProviders2zQuQM5i3_KHznOrfmbdIDVFUb9wY_Y7xrsSEXZ0s_UMeta || {}), ...{"middleware":"staff"} },
    component: () => import("/grouper/enterprise/web-frontend/modules/grouper_enterprise/pages/admin/authProviders.vue")
  },
  {
    name: "admin-audit-log",
    path: "/admin/audit-log",
    meta: { ...(auditLogTG8W65YcbUeI3hjsPTBE_QZ57_bthIiF_jLdRWsu0Y4Meta || {}), ...{"middleware":"authenticated"} },
    component: () => import("/grouper/enterprise/web-frontend/modules/grouper_enterprise/pages/auditLog.vue")
  },
  {
    name: "admin-data-scanner",
    path: "/admin/data-scanner",
    meta: { ...(dataScannerzn_w6ov_ZNoAniBcQe8z7zW5mU_0hHyrK8SMtQnMwsQMeta || {}), ...{"middleware":"staff"} },
    redirect: "/admin/data-scanner/scans",
    component: () => import("/grouper/enterprise/web-frontend/modules/grouper_enterprise/pages/admin/dataScanner.vue"),
    children: [
  {
    name: "admin-data-scanner-scans",
    path: "scans",
    component: () => import("/grouper/enterprise/web-frontend/modules/grouper_enterprise/pages/admin/dataScanner/scans.vue")
  },
  {
    name: "admin-data-scanner-results",
    path: "results",
    component: () => import("/grouper/enterprise/web-frontend/modules/grouper_enterprise/pages/admin/dataScanner/results.vue")
  }
]
  },
  {
    name: "workspace-audit-log",
    path: "/workspace/:workspaceId/audit-log",
    meta: { ...(auditLogTG8W65YcbUeI3hjsPTBE_QZ57_bthIiF_jLdRWsu0Y4Meta || {}), ...{"middleware":"authenticated"} },
    component: () => import("/grouper/enterprise/web-frontend/modules/grouper_enterprise/pages/auditLog.vue")
  }
]
  },
  {
    name: "workspace-invitation",
    path: "/workspace-invitation/:token",
    meta: {"preventPageViewTracking":true},
    component: () => import("/grouper/web-frontend/modules/core/pages/workspaceInvitation.vue")
  },
  {
    name: "health-check",
    path: "/_health/:trailing()?",
    component: () => import("/grouper/web-frontend/modules/core/pages/_health.vue")
  },
  {
    name: "notification-redirect",
    path: "/notification/:workspaceId/:notificationId",
    component: () => import("/grouper/web-frontend/modules/core/pages/notificationRedirect.vue")
  },
  {
    name: "onboarding",
    path: "/onboarding",
    meta: {"middleware":["settings","authenticated","redirectCompletedOnboarding","settings","authenticated","redirectCompletedOnboarding"]},
    component: () => import("/grouper/web-frontend/modules/core/pages/onboarding.vue")
  },
  {
    name: "database-table",
    path: "/database/:databaseId/table/:tableId/:viewId?",
    meta: { ...(tableXyFyWTpJnD76w8sU_k6raf1bWMP0nYzwEVHLLrlLAIoMeta || {}), ...{"middleware":["settings","authenticated","workspacesAndApplications","tableLoading","selectWorkspaceDatabaseTable","pendingJobs","settings","authenticated","workspacesAndApplications","tableLoading","selectWorkspaceDatabaseTable","pendingJobs"]} },
    component: () => import("/grouper/web-frontend/modules/database/pages/table.vue"),
    children: [
  {
    name: "database-table-row",
    path: "row/:rowId",
    component: () => import("/grouper/web-frontend/modules/core/components/RouterViewPlaceholder.vue")
  },
  {
    name: "database-table-open-webhooks",
    path: "webhooks",
    component: () => import("/grouper/web-frontend/modules/database/pages/table/webhooks.vue")
  },
  {
    name: "database-table-open-configure-data-sync",
    path: "configure-data-sync/:selectedPage?",
    component: () => import("/grouper/web-frontend/modules/database/pages/table/configureDataSync.vue")
  }
]
  },
  {
    path: "/api/docs",
    name: "database-api-docs-redirect",
    redirect: "/api-docs"
  },
  {
    path: "/api/docs/database/:databaseId",
    name: "database-api-docs-details-redirect",
    redirect: "/api-docs/database/:databaseId"
  },
  {
    name: "database-api-docs",
    path: "/api-docs",
    meta: { ...(APIDocsL2f4yWNeW2vbYc4UpokxeQa3QQjuGuF73EHTkOk8yP0Meta || {}), ...{"middleware":["workspacesAndApplications","workspacesAndApplications"]} },
    alias: ["/api/docs"],
    component: () => import("/grouper/web-frontend/modules/database/pages/APIDocs.vue")
  },
  {
    name: "database-api-docs-detail",
    path: "/api-docs/database/:databaseId",
    meta: {"middleware":["workspacesAndApplications","workspacesAndApplications"]},
    component: () => import("/grouper/web-frontend/modules/database/pages/APIDocsDatabase.vue")
  },
  {
    name: "database-table-form",
    path: "/form/:slug",
    meta: {"middleware":["settings","settings"]},
    component: () => import("/grouper/web-frontend/modules/database/pages/form.vue")
  },
  {
    name: "database-public-grid-view",
    path: "/public/grid/:slug",
    meta: {"middleware":["settings","settings"]},
    component: () => import("/grouper/web-frontend/modules/database/pages/publicView.vue")
  },
  {
    name: "database-public-gallery-view",
    path: "/public/gallery/:slug",
    meta: {"middleware":["settings","settings"]},
    component: () => import("/grouper/web-frontend/modules/database/pages/publicView.vue")
  },
  {
    name: "database-public-view-auth",
    path: "/public/auth/:slug",
    meta: { ...(publicViewLoginjhq6miIAhoYj5jxk0lsy5gETn4U_K_94iEMS5CgYvzwMeta || {}), ...{"layout":"login"} },
    component: () => import("/grouper/web-frontend/modules/database/pages/publicViewLogin.vue")
  },
  {
    name: "dashboard-application",
    path: "/dashboard/:dashboardId",
    meta: { ...(dashboard642NDUzvpj1oMZTbAGWrbfwtIWfQF1jSTxeHO4hdcDsMeta || {}), ...{"middleware":["settings","authenticated","workspacesAndApplications","dashboardLoading","settings","authenticated","workspacesAndApplications","dashboardLoading"]} },
    component: () => import("/grouper/web-frontend/modules/dashboard/pages/dashboard.vue")
  },
  {
    name: "builder-page",
    path: "/builder/:builderId/page/:pageId",
    meta: { ...(pageEditorI266LinBIjafvSzOzPbxg2lBdDZVnWuDQHkvsy2z7fgMeta || {}), ...{"middleware":["settings","authenticated","workspacesAndApplications","selectWorkspaceBuilderPage","pendingJobs","settings","authenticated","workspacesAndApplications","selectWorkspaceBuilderPage","pendingJobs"]} },
    component: () => import("/grouper/web-frontend/modules/builder/pages/pageEditor.vue")
  },
  {
    name: "application-builder-page",
    path: "/:pathMatch(.*)*",
    meta: {"publishedBuilderRoute":true},
    component: () => import("/grouper/web-frontend/modules/builder/pages/publicPage.vue")
  },
  {
    name: "builder-health-check",
    path: "/_health",
    meta: {"publishedBuilderRoute":true},
    component: () => import("/grouper/web-frontend/modules/core/pages/_health.vue")
  },
  {
    name: "application-builder-preview",
    path: "/builder/:builderId/preview/:pathMatch(.*)*",
    component: () => import("/grouper/web-frontend/modules/builder/pages/publicPage.vue")
  },
  {
    name: "automation-workflow",
    path: "/automation/:automationId/workflow/:workflowId",
    meta: { ...(automationWorkflowISmVSx60pQI5m2_M8JR34WBff1CGxIcq7TtDS2kd00UMeta || {}), ...{"middleware":["settings","authenticated","workspacesAndApplications","selectWorkspaceAutomationWorkflow","pendingJobs","settings","authenticated","workspacesAndApplications","selectWorkspaceAutomationWorkflow","pendingJobs"]} },
    component: () => import("/grouper/web-frontend/modules/automation/pages/automationWorkflow.vue")
  },
  {
    name: "database-public-kanban-view",
    path: "/public/kanban/:slug",
    meta: {"middleware":["settings","settings"]},
    component: () => import("@grouper/modules/database/pages/publicView.vue")
  },
  {
    name: "database-public-calendar-view",
    path: "/public/calendar/:slug",
    meta: {"middleware":["settings","settings"]},
    component: () => import("@grouper/modules/database/pages/publicView.vue")
  },
  {
    name: "database-public-timeline-view",
    path: "/public/timeline/:slug",
    meta: {"middleware":["settings","settings"]},
    component: () => import("@grouper/modules/database/pages/publicView.vue")
  }
]